import * as React from 'react'

function FacebookIcon (props)
{
	const output =
	(
		<svg xmlns="http://www.w3.org/2000/svg" width={ 1024 } height={ 1024 }
			viewBox="0 0 1024 1024" { ...props }>
		<title>Facebook</title>
		<path fill="currentColor" d="M674.539 170.027h93.483v-162.816c-16.128-2.219-71.595-7.211-136.192-7.211-134.784 0-227.115 84.779-227.115 240.597v143.403h-148.736v182.016h148.736v457.984h182.357v-457.941h142.72l22.656-182.016h-165.419v-125.397c0.043-52.608 14.208-88.619 87.509-88.619z" />
		</svg>
	);

	return output;
}

export default FacebookIcon
